<script setup lang="ts">
import type { UIProp } from '~/types/elementsUi'

interface SocialMediaIconsProps {
  ui?: UIProp<'base'>
}

const props = defineProps<SocialMediaIconsProps>()
</script>

<template>
  <div class="columns flex justify-center" :class="ui?.base">
    <VLink
      class="column narrow"
      target="_blank"
      href="https://www.facebook.com/ThuisgekooktNL/"
      sr-label="links.a11y.facebook"
      data-no-narration
    >
      <VIcon
        icon-pack="fa-brands"
        icon="fa-facebook-f"
        font-awesome-icon-size="2x"
        color="black"
        dark-color="white"
        aria-hidden="true"
      />
    </VLink>
    <VLink
      class="column narrow"
      target="_blank"
      href="https://www.instagram.com/thuisgekookt/"
      sr-label="links.a11y.instagram"
      data-no-narration
    >
      <VIcon
        icon-pack="fa-brands"
        icon="fa-instagram"
        font-awesome-icon-size="2x"
        color="black"
        dark-color="white"
        aria-hidden="true"
      />
    </VLink>
    <VLink
      class="column narrow"
      target="_blank"
      href="https://nl.pinterest.com/thuisgekookt/"
      sr-label="links.a11y.pinterest"
      data-no-narration
    >
      <VIcon
        icon-pack="fa-brands"
        icon="fa-pinterest-p"
        font-awesome-icon-size="2x"
        color="black"
        dark-color="white"
        aria-hidden="true"
      />
    </VLink>
    <VLink
      class="column narrow"
      target="_blank"
      href="https://www.linkedin.com/company/thuisgekookt"
      sr-label="links.a11y.linkedin"
      data-no-narration
    >
      <VIcon
        icon-pack="fa-brands"
        icon="fa-linkedin-in"
        font-awesome-icon-size="2x"
        color="black"
        dark-color="white"
        aria-hidden="true"
      />
    </VLink>
    <VLink
      class="column narrow"
      target="_blank"
      href="https://www.youtube.com/channel/UCYzMazH-n0hx2GObF5jD2VQ"
      sr-label="links.a11y.youtube"
      data-no-narration
    >
      <VIcon
        icon-pack="fa-brands"
        icon="fa-youtube"
        font-awesome-icon-size="2x"
        color="black"
        dark-color="white"
        aria-hidden="true"
      />
    </VLink>
  </div>
</template>

<style scoped></style>
